import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';

export function CreateAuthorizationSubmissionsFormFields() {
  return (
    <>
      <ParentBlockSelectField
        fieldName="config.payload"
        label="AuthorizationSubmissions Source"
        helperText={getSourceBlockNameHelperText('AuthorizationSubmissions')}
      />
      <ParentBlockSelectField
        fieldName="config.order.sourceBlockName"
        label="Order Source"
        required
        helperText={getSourceBlockNameHelperText('Order')}
      />
    </>
  );
}
